/**
 * Subscription Management Platform API
 * This document describes the functionality of the API belonging to the Subscription Management Platform ## Parameters ### Parameters with type \"array[string]\" or \"array[integer]\" should be given as multiple parameters with same key and different values    * param=A&param=B&param=C    * param=0&param=1&param=2
 *
 * OpenAPI spec version: 2.0.7
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent }                           from '@angular/common/http';
import { CustomHttpUrlEncodingCodec }                        from '../encoder';

import { Observable }                                        from 'rxjs/Observable';

import { RESPONSEITEM } from '../model/rESPONSEITEM';
import { SUBSCRIPTIONIMPORTPERSODATA } from '../model/sUBSCRIPTIONIMPORTPERSODATA';
import { TRANSACTIONINFO } from '../model/tRANSACTIONINFO';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';


@Injectable()
export class ProfilesService {

    protected basePath = 'https://localhost';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (let consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * 
     * Delete a profile and all associated personalization data from the database without the requirement of knowing the EID. If a profile is bound to an EID it will be deleted via ES3 interface.  **GSMA Interfaces endpoint(s):** &gt;*ES3.DeleteISDP*
     * @param iccid ICCID of the profile and associated personalization data to delete
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public profilesIccidDelete(iccid: string, observe?: 'body', reportProgress?: boolean): Observable<TRANSACTIONINFO>;
    public profilesIccidDelete(iccid: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<TRANSACTIONINFO>>;
    public profilesIccidDelete(iccid: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<TRANSACTIONINFO>>;
    public profilesIccidDelete(iccid: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (iccid === null || iccid === undefined) {
            throw new Error('Required parameter iccid was null or undefined when calling profilesIccidDelete.');
        }

        let headers = this.defaultHeaders;

        // authentication (basicAuth) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set("Accept", httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        let consumes: string[] = [
        ];

        return this.httpClient.delete<TRANSACTIONINFO>(`${this.basePath}/profiles/${encodeURIComponent(String(iccid))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * Update the MSISDN of a profile without the requirement of knowing the EID
     * @param iccid ICCID of the profile
     * @param msisdn MSISDN which should be set for the profile
     * @param useBootstrap if set, the bootstrap profile in SM-SR will be updated, otherwise SM-DP profile is affected
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public profilesIccidMsisdnPut(iccid: string, msisdn: string, useBootstrap?: boolean, observe?: 'body', reportProgress?: boolean): Observable<RESPONSEITEM>;
    public profilesIccidMsisdnPut(iccid: string, msisdn: string, useBootstrap?: boolean, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<RESPONSEITEM>>;
    public profilesIccidMsisdnPut(iccid: string, msisdn: string, useBootstrap?: boolean, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<RESPONSEITEM>>;
    public profilesIccidMsisdnPut(iccid: string, msisdn: string, useBootstrap?: boolean, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (iccid === null || iccid === undefined) {
            throw new Error('Required parameter iccid was null or undefined when calling profilesIccidMsisdnPut.');
        }
        if (msisdn === null || msisdn === undefined) {
            throw new Error('Required parameter msisdn was null or undefined when calling profilesIccidMsisdnPut.');
        }

        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (useBootstrap !== undefined) {
            queryParameters = queryParameters.set('useBootstrap', <any>useBootstrap);
        }

        let headers = this.defaultHeaders;

        // authentication (basicAuth) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set("Accept", httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        let consumes: string[] = [
        ];
        let httpContentTypeSelected:string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set("Content-Type", httpContentTypeSelected);
        }

        return this.httpClient.put<RESPONSEITEM>(`${this.basePath}/profiles/${encodeURIComponent(String(iccid))}/msisdn`,
            msisdn,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * Update multiple personalization data of a profile without the requirement of knowing the EID
     * @param iccid ICCID of the profile and associated personalization data to update
     * @param persoDataBatch 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public profilesIccidPersoPut(iccid: string, persoDataBatch: Array<SUBSCRIPTIONIMPORTPERSODATA>, observe?: 'body', reportProgress?: boolean): Observable<RESPONSEITEM>;
    public profilesIccidPersoPut(iccid: string, persoDataBatch: Array<SUBSCRIPTIONIMPORTPERSODATA>, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<RESPONSEITEM>>;
    public profilesIccidPersoPut(iccid: string, persoDataBatch: Array<SUBSCRIPTIONIMPORTPERSODATA>, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<RESPONSEITEM>>;
    public profilesIccidPersoPut(iccid: string, persoDataBatch: Array<SUBSCRIPTIONIMPORTPERSODATA>, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (iccid === null || iccid === undefined) {
            throw new Error('Required parameter iccid was null or undefined when calling profilesIccidPersoPut.');
        }
        if (persoDataBatch === null || persoDataBatch === undefined) {
            throw new Error('Required parameter persoDataBatch was null or undefined when calling profilesIccidPersoPut.');
        }

        let headers = this.defaultHeaders;

        // authentication (basicAuth) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set("Accept", httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        let consumes: string[] = [
        ];
        let httpContentTypeSelected:string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set("Content-Type", httpContentTypeSelected);
        }

        return this.httpClient.put<RESPONSEITEM>(`${this.basePath}/profiles/${encodeURIComponent(String(iccid))}/perso`,
            persoDataBatch,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}



// WEBPACK FOOTER //
// ./src/gen/swagger-api/api/profiles.service.ts